/**
 * ZDF's themes, in TypeScript until partner themes can come from a file; then
 * this folder leaves core along with ZDF's font files.
 */

import type { PartialTheme } from '@repo/theme';
import { defineFontGroup } from 'config/theme/font-group';

import { zdfColorsDark } from './zdf-color-dark';
import { zdfColorsLight } from './zdf-color-light';
import { zdfKikaAvatarColors, zdfKikaColors } from './zdf-kika-color.ts';
import { zdfLogoColors } from './zdf-logo-color.ts';
import { zdfStreamingPortalColors } from './zdf-streaming-portal-colors.ts';

export const zdfThemeNames = ['zdf', 'zdfHeuteDark', 'zdfHeuteLight', 'zdfKika', 'zdfStreamingPortal', 'zdfLogo'] as const;
export type ZdfThemeName = (typeof zdfThemeNames)[number];

/**
 * ZDFType, shared by every ZDF theme below.
 *
 * Named for the typeface rather than any one theme, so a sub-brand that gains
 * its own face can point at a different group without disturbing the rest.
 */
const zdfTypeFonts = defineFontGroup({
    name: 'zdfType',
    fallbacks: ['Helvetica', 'Roboto', 'sans-serif'],
    loadFontAssets: async () => (await import('./zdf-font.ts')).getZdfFontAssets(),
});

export const zdfThemes: Record<ZdfThemeName, PartialTheme> = {
    zdf: {
        colors: zdfColorsDark,
        fonts: zdfTypeFonts,
    },
    zdfHeuteDark: {
        colors: zdfColorsDark,
        fonts: zdfTypeFonts,
    },
    zdfHeuteLight: {
        colors: zdfColorsLight,
        fonts: zdfTypeFonts,
    },
    zdfKika: {
        colors: zdfKikaColors,
        avatarColors: zdfKikaAvatarColors,
        fonts: zdfTypeFonts,
    },
    zdfStreamingPortal: {
        colors: zdfStreamingPortalColors,
        fonts: zdfTypeFonts,
    },
    zdfLogo: {
        colors: zdfLogoColors,
        fonts: zdfTypeFonts,
    },
};
